import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-modify-product-master-group',
  templateUrl: './modify-product-master-group.component.html',
  styleUrls: ['./modify-product-master-group.component.css']
})
export class ModifyProductMasterGroupComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
